export default {
      id: "ic-misc-list-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-list-usage",
      toString: function () {
        return this.url;
      }
    }